import BaseController from '../baseSystemController';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../../utils/constants';
import eStartPopupControllerTypes from './eStartPopupControllerTypes';
import ControllerDropdown from '../../common/dropdown';

export default class ControllerRealityCheckStartPopup extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eButtonsTypes = {
      EBT_SUBMIT: 'submit_button',
    };
    this._eEventTypes = {
      SUBMIT_CLICK: this.getEventName(this._eButtonsTypes.EBT_SUBMIT),
    };
    this._eControllersClasses = {
      [this.controllerTypes.EPCT_DROPDOWN]: ControllerDropdown,
    }
    this._eElementsTypes = {
      EET_SCROLL_CONTAINER: 'scroll_container',
      EET_DESCRIPTION: 'description',
      EET_DROPDOWN_LABEL: 'dropdown_label',
      EET_CONTAINER_DROPDOWN: this.controllerTypes.EPCT_DROPDOWN,
      EET_BUTTON_SUBMIT: this._eButtonsTypes.EBT_SUBMIT,
      EET_DESCRIPTION_2: 'description_2',
    };

    this._localizations = {
      [this._eElementsTypes.EET_DESCRIPTION]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.startDesc`,
      [this._eElementsTypes.EET_DROPDOWN_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.next_notification`,
      [this._eElementsTypes.EET_DESCRIPTION_2]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.bottomDesc`,
      [this._eElementsTypes.EET_BUTTON_SUBMIT]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.common.submit`,
    }

    this.init(container);
  }

  _addExtraControllersListeners() {
    super._addExtraControllersListeners();
    const controllerDropdown = this.controllers[this.controllerTypes.EPCT_DROPDOWN];
    const scrollContainer = this.interactiveElements[this._eElementsTypes.EET_SCROLL_CONTAINER];

    controllerDropdown.on(controllerDropdown.events[this.controllerTypes.EPCT_DROPDOWN].DROPDOWN_TOGGLE, (visible) => {
      if (!visible) return;
      this._scrollTimeout = setTimeout(() => scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior: 'smooth' }), 300);
    });
  }

  cleanup() {
    super.cleanup();
    clearTimeout(this._scrollTimeout);
  }

  set timeoutOptions(options) {
    this.controllers[this.controllerTypes.EPCT_DROPDOWN].options = options;
  }

  set activeTimeout(value) {
    this.controllers[this.controllerTypes.EPCT_DROPDOWN].activeOption = value;
  }

  get controllerTypes() {
    return eStartPopupControllerTypes;
  }

  _getMarkup() {
    return `<div class="system-ui-container__modal__reality_check__container__body__scroll_container" id=${this.interactiveElementsIds[this._eElementsTypes.EET_SCROLL_CONTAINER]}>
        <p id=${this.interactiveElementsIds[this._eElementsTypes.EET_DESCRIPTION]} class="system-ui-container__modal__reality_check__container__description">
          ${this._getLocalization(this._localizations[this._eElementsTypes.EET_DESCRIPTION])}
        </p>
        
        <div class="system-ui-container__modal__reality_check__container__container_dropdown">
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_DROPDOWN_LABEL]}>
            ${this._getLocalization(this._localizations[this._eElementsTypes.EET_DROPDOWN_LABEL])}
          </span>
          <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER_DROPDOWN]}>
          </div>
        </div>
        </div>
        
        <div class="system-ui-container__modal__reality_check__container__submit_wrapper">
          <div class="system-ui-container__modal__reality_check__container__submit_wrapper__controls">
            <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_BUTTON_SUBMIT]} class="system-ui-container__modal__reality_check__container__submit_wrapper__controls__submit">
               ${this._getLocalization(this._localizations[this._eElementsTypes.EET_BUTTON_SUBMIT])}
            </button>
          </div>
          
          <p class="system-ui-container__modal__reality_check__container__submit_wrapper__bottom_description" id=${this.interactiveElementsIds[this._eElementsTypes.EET_DESCRIPTION_2]}>
            ${this._getLocalization(this._localizations[this._eElementsTypes.EET_DESCRIPTION_2])}
          </p>
        </div>`
  }
}
